import { User } from '@app/models';
import { UserLabel } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum LabelActionTypes {
  FetchLabels = '[Label] Fetch Labels',
  FetchLabelsSuccess = '[Label] Fetch Labels Success',
  FetchLabelsFail = '[Label] Fetch Labels Fail',
  SelectLabel = '[Label] Select Label',
  SearchDossiersByLabels = '[Label] Search Dossiers By Labels',

  CreateDossierLabel = '[DossierLabels] Create Dossier Label',
  CreateDossierLabelSuccess = '[DossierLabels] Create Dossier Label Success',
  CreateDossierLabelFail = '[DossierLabels] Create Dossier Label Fail',

  SearchLabel = '[Label] Search Label',
  ResetSearch = '[Label] Reset Search',

  ConfirmLabelRemoval = '[Label] Confirm Label Removal',
  RemoveLabel = '[Label] Remove Label',
  RemoveLabelSuccess = '[Label] Remove Label Success',
  RemoveLabelFail = '[Label] Remove Label Fail',

  SaveLabel = '[Label] Save Label',
  SaveLabelSuccess = '[Label] Save Label Success',
  SaveLabelFail = '[Label] Save Label Fail',

  UpdateLabelSharedType = '[Label] Update Label Shared Type'
}

export class FetchLabels implements Action {
  readonly type = LabelActionTypes.FetchLabels;
}

export class FetchLabelsSuccess implements Action {
  readonly type = LabelActionTypes.FetchLabelsSuccess;

  constructor(public payload: UserLabel[]) {
  }
}

export class FetchLabelsFail implements Action {
  readonly type = LabelActionTypes.FetchLabelsFail;

  constructor(public payload: Error) {
  }
}

export class SelectLabel implements Action {
  readonly type = LabelActionTypes.SelectLabel;

  constructor(public payload: UserLabel) {
  }
}

export class SearchDossiersByLabels implements Action {
  readonly type = LabelActionTypes.SearchDossiersByLabels;
}

export class CreateDossierLabel implements Action {
  readonly type = LabelActionTypes.CreateDossierLabel;

  constructor(public payload: string) {
  }
}

export class CreateDossierLabelSuccess implements Action {
  readonly type = LabelActionTypes.CreateDossierLabelSuccess;

  constructor(public payload: UserLabel) {
  }
}

export class CreateDossierLabelFail implements Action {
  readonly type = LabelActionTypes.CreateDossierLabelFail;

  constructor(public payload: Error) {
  }
}

export class SearchLabel implements Action {
  readonly type = LabelActionTypes.SearchLabel;

  constructor(public payload: string) {
  }
}

export class ResetSearch implements Action {
  readonly type = LabelActionTypes.ResetSearch;
}

export class ConfirmLabelRemoval implements Action {
  readonly type = LabelActionTypes.ConfirmLabelRemoval;

  constructor(public payload: UserLabel) {
  }
}

export class RemoveLabel implements Action {
  readonly type = LabelActionTypes.RemoveLabel;

  constructor(public payload: number) {
  }
}

export class RemoveLabelSuccess implements Action {
  readonly type = LabelActionTypes.RemoveLabelSuccess;

  constructor(public payload: number) {
  }
}

export class RemoveLabelFail implements Action {
  readonly type = LabelActionTypes.RemoveLabelFail;

  constructor(public payload: Error) {
  }
}

export class SaveLabel implements Action {
  readonly type = LabelActionTypes.SaveLabel;

  constructor(public payload: UserLabel) {
  }
}

export class SaveLabelSuccess implements Action {
  readonly type = LabelActionTypes.SaveLabelSuccess;

  constructor(public payload: UserLabel) {
  }
}

export class SaveLabelFail implements Action {
  readonly type = LabelActionTypes.SaveLabelFail;

  constructor(public payload: Error) {
  }
}

export class UpdateLabelSharedType implements Action {
  readonly type = LabelActionTypes.UpdateLabelSharedType;

  constructor(public payload: { sharedUsers: User[]; labelId: number }) {
  }
}

export type LabelActions =
  | FetchLabels
  | FetchLabelsSuccess
  | FetchLabelsFail
  | SelectLabel
  | SearchDossiersByLabels
  | CreateDossierLabelSuccess
  | CreateDossierLabelFail
  | SearchLabel
  | ResetSearch
  | ConfirmLabelRemoval
  | RemoveLabel
  | RemoveLabelSuccess
  | RemoveLabelFail
  | UpdateLabelSharedType
  | SaveLabel
  | SaveLabelSuccess
  | SaveLabelFail;
